import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
import { EReportExecutiveSummaryCustomerSourcedInput } from './report';
// Define the DateAggregation enum
export let EExecutiveSummaryFilterDateAggregation;
(function (EExecutiveSummaryFilterDateAggregation) {
  EExecutiveSummaryFilterDateAggregation["Hour"] = "hour";
  EExecutiveSummaryFilterDateAggregation["Day"] = "day";
  EExecutiveSummaryFilterDateAggregation["Week"] = "week";
  EExecutiveSummaryFilterDateAggregation["Month"] = "month";
  EExecutiveSummaryFilterDateAggregation["Quarter"] = "quarter";
  EExecutiveSummaryFilterDateAggregation["Year"] = "year";
})(EExecutiveSummaryFilterDateAggregation || (EExecutiveSummaryFilterDateAggregation = {}));
export let EUserPasswordHashAlgorithm;
(function (EUserPasswordHashAlgorithm) {
  EUserPasswordHashAlgorithm["Md5"] = "md5";
  EUserPasswordHashAlgorithm["Sha256"] = "sha256";
  EUserPasswordHashAlgorithm["Sha512"] = "sha512";
  EUserPasswordHashAlgorithm["Bcrypt"] = "bcrypt";
})(EUserPasswordHashAlgorithm || (EUserPasswordHashAlgorithm = {}));
export let EUserType;
(function (EUserType) {
  EUserType["Doctor"] = "doctor";
  EUserType["Staff"] = "staff";
  EUserType["Patient"] = "patient";
  EUserType["Guest"] = "guest";
  EUserType["System"] = "system";
})(EUserType || (EUserType = {}));
export let EUserDisplayStatus;
(function (EUserDisplayStatus) {
  EUserDisplayStatus["Active"] = "active";
  EUserDisplayStatus["Pending"] = "pending";
  EUserDisplayStatus["Suspended"] = "suspended";
})(EUserDisplayStatus || (EUserDisplayStatus = {}));
export let EUserContactType;
(function (EUserContactType) {
  EUserContactType["Inapp"] = "inapp";
  EUserContactType["Sms"] = "sms";
  EUserContactType["Voice"] = "voice";
  EUserContactType["Email"] = "email";
  EUserContactType["Fax"] = "fax";
  EUserContactType["Whatsapp"] = "whatsapp";
})(EUserContactType || (EUserContactType = {}));
export let EUserContactArchivedReason;
(function (EUserContactArchivedReason) {
  EUserContactArchivedReason["None"] = "none";
  EUserContactArchivedReason["Unreachable"] = "unreachable";
  EUserContactArchivedReason["DoNotContact"] = "do-not-contact";
})(EUserContactArchivedReason || (EUserContactArchivedReason = {}));
export let EUserSalesforceDataOnboardingStage;
(function (EUserSalesforceDataOnboardingStage) {
  EUserSalesforceDataOnboardingStage["CustomerSuccessIntroduction"] = "Customer Success Introduction";
  EUserSalesforceDataOnboardingStage["Kickoff"] = "Kickoff";
  EUserSalesforceDataOnboardingStage["Integration"] = "Integration";
  EUserSalesforceDataOnboardingStage["DiscoveryCall"] = "Discovery Call";
  EUserSalesforceDataOnboardingStage["Customization"] = "Customization";
  EUserSalesforceDataOnboardingStage["Testing"] = "Testing";
  EUserSalesforceDataOnboardingStage["StaffTraining"] = "Staff Training";
  EUserSalesforceDataOnboardingStage["ReadyToLaunch"] = "Ready To Launch";
  EUserSalesforceDataOnboardingStage["GoLive"] = "Go-Live";
  EUserSalesforceDataOnboardingStage["FullyImplemented"] = "Fully Implemented";
})(EUserSalesforceDataOnboardingStage || (EUserSalesforceDataOnboardingStage = {}));
export let EUserSalesforceDataAccountLifeline;
(function (EUserSalesforceDataAccountLifeline) {
  EUserSalesforceDataAccountLifeline["Unassigned"] = "Unassigned";
  EUserSalesforceDataAccountLifeline["Assigned"] = "Assigned";
  EUserSalesforceDataAccountLifeline["SalesAccepted"] = "Sales Accepted";
  EUserSalesforceDataAccountLifeline["Working"] = "Working";
  EUserSalesforceDataAccountLifeline["SalesQualified"] = "Sales Qualified";
  EUserSalesforceDataAccountLifeline["OpenOpportunity"] = "Open Opportunity";
  EUserSalesforceDataAccountLifeline["Nurture"] = "Nurture";
  EUserSalesforceDataAccountLifeline["Disqualified"] = "Disqualified";
  EUserSalesforceDataAccountLifeline["Trial"] = "Trial";
  EUserSalesforceDataAccountLifeline["Converted"] = "Converted";
  EUserSalesforceDataAccountLifeline["Active"] = "Active";
  EUserSalesforceDataAccountLifeline["Churned"] = "Churned";
  EUserSalesforceDataAccountLifeline["Partnered"] = "Partnered";
  EUserSalesforceDataAccountLifeline["TrialEndedNoConversion"] = "Trial Ended (No Conversion)";
})(EUserSalesforceDataAccountLifeline || (EUserSalesforceDataAccountLifeline = {}));
export let EProvisioning;
(function (EProvisioning) {
  EProvisioning["AppointmentChecklist"] = "appointment-checklist";
  EProvisioning["Branding"] = "branding";
  EProvisioning["Broadcast"] = "broadcast";
  EProvisioning["Chat"] = "chat";
  EProvisioning["DigitalCallDeflection"] = "digital-call-deflection";
  EProvisioning["Feedback"] = "feedback";
  EProvisioning["Followup"] = "followup";
  EProvisioning["Form"] = "form";
  EProvisioning["GoogleAvailabilities"] = "google-availabilities";
  EProvisioning["Insurance"] = "insurance";
  EProvisioning["InsuranceVerification"] = "insurance-verification";
  EProvisioning["IntakeForm"] = "intake-form";
  EProvisioning["Lumabot"] = "lumabot";
  EProvisioning["LumaPay"] = "luma-pay";
  EProvisioning["OutboundReferral"] = "outbound-referral";
  EProvisioning["PrequalForm"] = "prequal-form";
  EProvisioning["Recall"] = "recall";
  EProvisioning["Referral"] = "referral";
  EProvisioning["Reminder"] = "reminder";
  EProvisioning["Scheduler"] = "scheduler";
  EProvisioning["SchedulerAssist"] = "scheduler-assist";
  EProvisioning["Telehealth"] = "telehealth";
  EProvisioning["Upload"] = "upload";
  EProvisioning["WaitingRoom"] = "waiting-room";
  EProvisioning["Waitlist"] = "waitlist";
})(EProvisioning || (EProvisioning = {}));
export let ERollout; // Rollouts to migrate the patient-web-app into nexty (DONE):
// NextyPatientForms = 'nexty-patient-forms',
(function (ERollout) {
  ERollout["AdvancedSchedulerOptions"] = "advanced-scheduler-options";
  ERollout["Automations"] = "automations";
  ERollout["BiDiForms"] = "bidi-forms";
  ERollout["CCDA"] = "ccda";
  ERollout["ChatInternalLinks"] = "chatInternalLinks";
  ERollout["ChecklistTemplate"] = "checklist-template";
  ERollout["Cobranding"] = "cobranding";
  ERollout["CopayDetermination"] = "copay-determination";
  ERollout["CustomFormsV2"] = "custom-forms-v2";
  ERollout["DesignatedNumbers"] = "designated-numbers";
  ERollout["Docusign"] = "docusign";
  ERollout["DropdownV2"] = "dropdown-v2";
  ERollout["EHRIntegrators"] = "ehr-integrators";
  ERollout["EmbedBranding"] = "embed-branding";
  ERollout["EnableNextyWelcomeBanner"] = "enable-nexty-welcome-banner";
  ERollout["EnableOldUI"] = "enable-old-ui";
  ERollout["ExecutiveSummary"] = "executive-summary";
  ERollout["ExternalId"] = "externalId";
  ERollout["FaxAutomation"] = "fax-automation";
  ERollout["FormBuilder"] = "formBuilder";
  ERollout["FormResponses"] = "form-responses";
  ERollout["HubV2"] = "hub-v2";
  ERollout["Journey"] = "journey";
  ERollout["JumpLogicV2"] = "jump-logic-v2";
  ERollout["Labs"] = "labs";
  ERollout["LinkedForms"] = "linked-forms";
  ERollout["LumaBotJumpV2"] = "lumabot-jump-v2";
  ERollout["LumaBotLiveChat"] = "lumabot-livechat";
  ERollout["LumaBotPoweredByLuma"] = "lumabot-poweredbyluma";
  ERollout["LumaBotSquigglies"] = "lumabot-squigglies";
  ERollout["LumaBotV2"] = "lumabot-v2";
  ERollout["Lumi"] = "lumi";
  ERollout["MessagingActivity"] = "messaging-activity";
  ERollout["OldBroadcasts"] = "old-broadcasts";
  ERollout["OmniChannelRetries"] = "omnichannel-retries";
  ERollout["PatientMerge"] = "patient-merge";
  ERollout["PaymentAudit"] = "payment-audit";
  ERollout["Reports"] = "reports";
  ERollout["SchedulerAssist"] = "scheduler-assist";
  ERollout["SchedulerV2"] = "schedulerV2";
  ERollout["ScheduleView"] = "schedule-view";
  ERollout["SettingsV2"] = "settings-v2";
  ERollout["SparkMonitoring"] = "spark-monitoring";
  ERollout["SpecialtyReferrals"] = "specialty-ehr-referrals";
  ERollout["ThirdPartyIntegration"] = "third-party-integration";
  ERollout["TokensPage"] = "tokens-page";
  ERollout["WaitlistsTags"] = "waitlists-tags";
  ERollout["ClinicApp"] = "clinic-app";
  ERollout["KioskApp"] = "kiosk-app";
  ERollout["NextyPatientFeedback"] = "nexty-patient-feedback";
  ERollout["NextyPatientInsurances"] = "nexty-patient-insurances";
  ERollout["NextyPatientSignup"] = "nexty-patient-signup";
  ERollout["NextyPatientAvailabilitySelector"] = "nexty-patient-availability-selector";
  ERollout["NextyPatientAppointments"] = "nexty-patient-appointments";
  ERollout["NextyPatientChat"] = "nexty-patient-chat";
  ERollout["NextyPatientChecklists"] = "nexty-patient-checklists";
  ERollout["NextyPatientHeader"] = "nexty-patient-header";
  ERollout["NextyPatientLogin"] = "nexty-patient-login";
  ERollout["NextyPatientLumaBot"] = "nexty-patient-luma-bot";
  ERollout["NextyPatientPayments"] = "nexty-patient-payments";
  ERollout["NextyPatientSessionIdle"] = "nexty-patient-session-idle";
  ERollout["NextyPatientSnackbars"] = "nexty-patient-snackbars";
})(ERollout || (ERollout = {}));
export let EUserSalesforceDataLifeline;
(function (EUserSalesforceDataLifeline) {
  EUserSalesforceDataLifeline["Trial"] = "trial";
  EUserSalesforceDataLifeline["Converted"] = "converted";
  EUserSalesforceDataLifeline["Active"] = "active";
  EUserSalesforceDataLifeline["Churn"] = "churn";
})(EUserSalesforceDataLifeline || (EUserSalesforceDataLifeline = {}));
export let EUserSalesforceDataHealthStatus;
(function (EUserSalesforceDataHealthStatus) {
  EUserSalesforceDataHealthStatus["Green"] = "green";
  EUserSalesforceDataHealthStatus["Yellow"] = "yellow";
  EUserSalesforceDataHealthStatus["Red"] = "red";
  EUserSalesforceDataHealthStatus["PoorFit"] = "poor fit";
  EUserSalesforceDataHealthStatus["Healthy"] = "Healthy";
  EUserSalesforceDataHealthStatus["Neutral"] = "Neutral";
  EUserSalesforceDataHealthStatus["ChurnRisk"] = "Churn Risk";
  EUserSalesforceDataHealthStatus["Advocate"] = "Advocate";
})(EUserSalesforceDataHealthStatus || (EUserSalesforceDataHealthStatus = {}));
export let EUserSalesforceDataBoardSegment;
(function (EUserSalesforceDataBoardSegment) {
  EUserSalesforceDataBoardSegment["Reseller"] = "Reseller";
  EUserSalesforceDataBoardSegment["Strategic"] = "Strategic";
  EUserSalesforceDataBoardSegment["Majors"] = "Majors";
  EUserSalesforceDataBoardSegment["Core"] = "Core";
  EUserSalesforceDataBoardSegment["Sub20"] = "Sub 20";
  EUserSalesforceDataBoardSegment["Unknown"] = "Unknown";
})(EUserSalesforceDataBoardSegment || (EUserSalesforceDataBoardSegment = {}));
export let EUserSource;
(function (EUserSource) {
  EUserSource["Sms"] = "sms";
  EUserSource["Voice"] = "voice";
  EUserSource["Email"] = "email";
  EUserSource["None"] = "none";
})(EUserSource || (EUserSource = {}));
export let EUserGender;
(function (EUserGender) {
  EUserGender["Male"] = "male";
  EUserGender["Female"] = "female";
  EUserGender["Unknown"] = "unknown";
  EUserGender["Nonbinary"] = "nonbinary";
})(EUserGender || (EUserGender = {}));
export let EUserDemoConfigurationType;
(function (EUserDemoConfigurationType) {
  EUserDemoConfigurationType["Default"] = "default";
  EUserDemoConfigurationType["LumaBot"] = "lumabot";
})(EUserDemoConfigurationType || (EUserDemoConfigurationType = {}));
export const fieldsUser = _extends({}, fieldsIBaseModel, {
  name: {
    type: 'Text'
  },
  normalizedName: {
    type: 'Text'
  },
  firstname: {
    type: 'Text'
  },
  lastname: {
    type: 'Text'
  },
  middlename: {
    type: 'Text'
  },
  displayPhone: {
    type: 'Text'
  },
  displayStatus: {
    type: 'Option',
    values: EUserDisplayStatus
  },
  email: {
    type: 'Text'
  },
  password: {
    type: 'Text'
  },
  passwordHashAlgorithm: {
    type: 'Option',
    values: EUserPasswordHashAlgorithm
  },
  passwordUpdatedAt: {
    type: 'Date'
  },
  safeId: {
    type: 'Text'
  },
  resetPasswordToken: {
    type: 'Text'
  },
  resetPasswordExpires: {
    type: 'Date'
  },
  type: {
    type: 'Option',
    values: EUserType
  },
  // roles: { type: 'Option', values: Role[] },
  // rolesByUser: { type: 'Option', values: UserRolesByUser },
  // organization: { type: 'ID', ref: EModel.Organization },
  // contact: { type: 'Option', values: UserContact[] },
  doNotContact: {
    type: 'Boolean'
  },
  doNotContactMessage: {
    type: 'ID',
    ref: EModel.Message
  },
  // groups: { type: 'Option', values: TRef<Group>[] },
  stripeCustomerId: {
    type: 'Text'
  },
  stripeSubscriptionId: {
    type: 'Text'
  },
  salesforceId: {
    type: 'Text'
  },
  // salesforceData: { type: 'Option', values: UserSalesforceData },
  lastLogin: {
    type: 'Date'
  },
  token: {
    type: 'Text'
  },
  active: {
    type: 'Number'
  },
  master: {
    type: 'Boolean'
  },
  language: {
    type: 'Text'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  // setting: { type: 'ID', ref: EModel.Setting },
  // settings: { type: 'Option', values: any },
  // externalId: { type: 'Option', values: UserExternalId },
  // secondaryExternalId: { type: 'Option', values: UserExternalId },
  // dateOfBirth: { type: 'Option', values: UserDateOfBirth },
  address: {
    type: 'Text'
  },
  address2: {
    type: 'Text'
  },
  city: {
    type: 'Text'
  },
  state: {
    type: 'Text'
  },
  country: {
    type: 'Text'
  },
  postcode: {
    type: 'Text'
  },
  gender: {
    type: 'Option',
    values: EUserGender
  },
  // twoFactorAuthSecret: { type: 'Option', values: UserTwoFactorAuthSecret },
  // allowedIps: { type: 'Option', values: string[] },
  // stats: { type: 'Option', values: UserStats },
  avatar: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  publicKey: {
    type: 'Text'
  },
  directMessagingEmail: {
    type: 'Text'
  },
  // demoConfiguration: { type: 'Option', values: UserDemoConfiguration },
  website: {
    type: 'Text'
  }
  // searchIds: { type: 'Option', values: string[] },
});